import { useState } from 'react';

import { cx } from '@libs/classnames';
import { CapsuleButton } from '@ui/components/CapsuleButton';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { Placeholder } from '@ui/components/Placeholder/Placeholder';
import { SearchInput } from '@ui/components/SearchInput';

import { ClubsListItem } from '@features/club/ui/ClubsList/ClubsListItem';
import { components } from '@features/shared/api/public';

import styles from './ClubsList.module.css';

type Props = {
  clubs?: components['schemas']['ClubPublicDto'][];
  query?: string;
  onQueryChange: (newQuery: string) => void;
  isLoading: boolean;
  onLoadMore?: () => void;
  myClubIds: string[];
};

export function ClubsList({
  clubs,
  query,
  onQueryChange,
  isLoading,
  onLoadMore,
  myClubIds,
}: Props) {
  const [isSearchCollapsed, setIsSearchCollapsed] = useState(true);
  const isMobile = useMediaQuery() === 'mobile';

  return (
    <div className={styles.clubsListWrapper}>
      <div className={styles.header}>
        <div
          className={cx(styles.title, {
            [styles.collapsed]: !isSearchCollapsed,
          })}
        >
          Все клубы
        </div>
        <div className={styles.search}>
          <SearchInput
            collapsible={isMobile}
            onCollapseChange={setIsSearchCollapsed}
            onQueryChange={onQueryChange}
            query={query}
            placeholder="Поиск по названию"
          />
        </div>
      </div>

      <div className={styles.clubsList}>
        <div className={styles.listHeader}>
          <div className={styles.clubName}>Шахматный клуб</div>
          <div className={styles.clubInfo}>
            <div className={styles.clubParticipants}>Участники</div>
            <div className={styles.clubEvents}>События</div>
          </div>
        </div>

        {clubs?.map((club) => (
          <ClubsListItem
            key={club.clubId}
            club={club}
            highlighted={myClubIds.some((clubId) => clubId === club.clubId)}
          />
        ))}

        {onLoadMore && (
          <div className={styles.loadMoreButton}>
            <CapsuleButton preset="gray" size="16m-40" onClick={onLoadMore}>
              Показать еще
            </CapsuleButton>
          </div>
        )}

        {!isLoading && clubs && !clubs.length && (
          <Placeholder>Нет клубов с таким названием</Placeholder>
        )}
      </div>
    </div>
  );
}
